var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemJournal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M18 2a2 2 0 0 1 2 2v13.436a2 2 0 0 1-2 2h-7.467V22l-1.666-1.282L7.2 22v-2.564H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zM8 4.051H6v13.334l2-.001zm10 0h-8v13.333h8zm-2 2.052a1 1 0 0 1 1 1v.05a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-.05a1 1 0 0 1 1-1z"
})));
export default SvgGemJournal;